import '../../App.css';
import MainSection from '../MainSection';
import react from 'react';

function Home() {
  return (
    <>
      <MainSection />
    </>
  );
}

export default Home;